
(function () {
  const buyTabsSections = document.querySelectorAll('[data-buy-tabs-block-id]');

  buyTabsSections.forEach((buyTabsSection) => {
    const blockId = buyTabsSection.dataset.buyTabsBlockId;
    if (!blockId) return;

    const radioInputs = buyTabsSection.querySelectorAll('.buy-tabs__radio[data-buy-mode]');
    const frequencySection = buyTabsSection.querySelector('[data-frequency-section]');
    const subscriptionCard = buyTabsSection.querySelector('[data-buy-mode-card="subscription"]');
    const singleCard = buyTabsSection.querySelector('[data-buy-mode-card="single"]');
    const sectionTitle = buyTabsSection.querySelector('.buy-tabs__section-title');
    const subscriptionPicker = buyTabsSection.querySelector('subscription-plans-picker');
    // Badge de remise rendu dans la ligne de prix : gardé ici pour être réinséré après chaque reconstruction.
    const subscriptionRibbon = buyTabsSection.querySelector('[data-subscription-ribbon]');

    /**
     * Returns the currently selected buy mode ('single' or 'subscription').
     * @returns {string}
     */
    function getSelectedMode() {
      const checked = buyTabsSection.querySelector('.buy-tabs__radio[data-buy-mode]:checked');
      return checked ? checked.dataset.buyMode : 'single';
    }

    /**
     * Activates the first bundle radio button (single unit) to update pricing.
     */
    function activateFirstBundle() {
      const bundleComponent = buyTabsSection.querySelector('product-packs-component');
      if (!bundleComponent) return;

      const firstRadio = bundleComponent.querySelector('input.product-packs__radio[value="single"]');
      if (firstRadio) {
        if (!firstRadio.checked) {
          firstRadio.checked = true;
        }
        firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /**
     * Clears selling_plan and selling_plan_group hidden inputs in the product form.
     */
    function clearSellingPlanInputs() {
      const formWrapper = buyTabsSection.querySelector('.buy-tabs__form-wrapper');
      if (!formWrapper) return;

      const form = formWrapper.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      const sellingPlanGroupInput = form.querySelector('input[name="selling_plan_group"]');
      if (sellingPlanInput) sellingPlanInput.value = '';
      if (sellingPlanGroupInput) sellingPlanGroupInput.value = '';
    }

    /**
     * Switches back to single purchase mode if the selected variant/pack has no subscription.
     * Called when variant or pack changes while in subscription mode.
     * @param {boolean} [keepPackSelection=false] - If true, don't reset pack to single unit
     */
    function switchToSingleIfNoSubscription(keepPackSelection = false) {
      if (getSelectedMode() !== 'subscription') return;

      const subscriptionAvailable = currentVariantAvailable && currentVariantHasSubscription && currentPackHasSubscription;
      if (!subscriptionAvailable) {
        const singleRadio = buyTabsSection.querySelector('.buy-tabs__radio[data-buy-mode="single"]');
        if (singleRadio) {
          singleRadio.checked = true;
          // Switch to single mode but optionally keep pack selection
          if (keepPackSelection) {
            // Only hide frequency picker and clear inputs, don't reset pack
            if (frequencySection) {
              frequencySection.setAttribute('hidden', '');
            }
            if (subscriptionPicker && typeof subscriptionPicker.deselectAll === 'function') {
              subscriptionPicker.deselectAll();
            }
            clearSellingPlanInputs();
          } else {
            onModeChange('single');
          }
        }
      }
    }

    // Last discount percentage computed from the displayed prices, 0 when the
    // subscription is not actually cheaper.
    let currentDiscountPercentage = 0;

    /**
     * Swaps the add-to-cart label for the subscription wording while the
     * subscription card is selected. The wording comes from the block setting
     * and its [discount] token is filled with the real percentage; without a
     * genuine discount the original label is kept.
     */
    function updateAddToCartLabel() {
      const label = buyTabsSection.querySelector('.add-to-cart-text__label');
      if (!(label instanceof HTMLElement)) return;

      if (label.dataset.defaultLabelHtml === undefined) {
        label.dataset.defaultLabelHtml = label.innerHTML;
      }

      const template = buyTabsSection.dataset.subscriptionCtaTemplate;
      const isSubscription = getSelectedMode() === 'subscription';

      if (!isSubscription || !template || currentDiscountPercentage <= 0) {
        label.innerHTML = label.dataset.defaultLabelHtml;
        return;
      }

      label.textContent = template.replace('[discount]', `${currentDiscountPercentage}%`);
    }

    /**
     * Handles mode switching when a radio card is selected.
     * @param {'single' | 'subscription'} mode
     */
    function onModeChange(mode) {
      if (mode === 'subscription') {
        const singlePlan = buyTabsSection.dataset.singleSellingPlan === 'true';

        if (singlePlan) {
          // Single plan: keep frequency picker hidden but force-select the only plan
          const radio = subscriptionPicker?.querySelector(
            '.subscription-plans-picker__radio[data-radio-type="selling_plan"]'
          );
          if (radio instanceof HTMLInputElement && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          // Multiple plans: show the frequency picker
          if (frequencySection) {
            frequencySection.removeAttribute('hidden');
          }
          if (subscriptionPicker && typeof subscriptionPicker.selectFirstSubscription === 'function') {
            subscriptionPicker.selectFirstSubscription();
          }
        }
      } else {
        // Hide frequency picker
        if (frequencySection) {
          frequencySection.setAttribute('hidden', '');
        }

        // Deselect all subscriptions and clear form inputs
        if (subscriptionPicker && typeof subscriptionPicker.deselectAll === 'function') {
          subscriptionPicker.deselectAll();
        }
        clearSellingPlanInputs();

        // Activate first bundle to refresh pricing
        activateFirstBundle();
      }
    }

    // Listen for radio card changes
    radioInputs.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const mode = event.target.dataset.buyMode;
        if (mode) {
          // If trying to select subscription but variant/pack doesn't have it, revert to single
          const subscriptionAvailable = currentVariantHasSubscription && currentPackHasSubscription;
          if (mode === 'subscription' && !subscriptionAvailable) {
            const singleRadio = buyTabsSection.querySelector('.buy-tabs__radio[data-buy-mode="single"]');
            if (singleRadio) {
              singleRadio.checked = true;
            }
            // Don't call onModeChange('subscription'), keep single mode
            return;
          }
          onModeChange(mode);
          updateAddToCartLabel();
        }
      });
    });

    /**
     * Tracks whether the current variant has subscription available.
     */
    let currentVariantHasSubscription = true;

    /**
     * Tracks whether the current pack has subscription available.
     */
    let currentPackHasSubscription = true;

    /**
     * Tracks whether the current variant is in stock (available for purchase).
     * Initialized from server-side rendered hidden class.
     */
    let currentVariantAvailable = !buyTabsSection.querySelector('.buy-tabs__card--hidden');

    /**
     * Checks if the current variant has subscription available.
     * @returns {boolean}
     */
    function checkVariantHasSubscription() {
      const variantPicker = buyTabsSection.querySelector('variant-picker');
      if (!variantPicker) return true;

      // Check radio buttons
      const selectedInput = variantPicker.querySelector('input[type="radio"]:checked[data-has-subscription]');
      // Check select dropdowns
      const selectedOption = variantPicker.querySelector('select option:checked[data-has-subscription]');

      if (selectedInput) {
        return selectedInput.dataset.hasSubscription === 'true';
      } else if (selectedOption) {
        return selectedOption.dataset.hasSubscription === 'true';
      }

      return true; // Default to available
    }

    /**
     * Checks if the selected pack has subscription available.
     * @returns {boolean}
     */
    function checkPackHasSubscription() {
      const selectedPackRadio = buyTabsSection.querySelector('product-packs-component .product-packs__radio:checked');
      if (!selectedPackRadio) return true;

      return selectedPackRadio.dataset.hasSellingPlans === 'true';
    }

    /**
     * Updates the visual state of the buy-mode cards based on all state variables.
     * Both cards and the section title are hidden when the variant is out of
     * stock; the subscription card is disabled when subscription is not
     * available for the variant/pack.
     */
    function updateCardsVisual() {
      if (singleCard) {
        singleCard.classList.toggle('buy-tabs__card--hidden', !currentVariantAvailable);
      }
      if (sectionTitle) {
        sectionTitle.classList.toggle('buy-tabs__card--hidden', !currentVariantAvailable);
      }
      if (subscriptionCard) {
        if (!currentVariantAvailable) {
          subscriptionCard.classList.add('buy-tabs__card--hidden');
          subscriptionCard.classList.remove('buy-tabs__card--disabled');
        } else {
          subscriptionCard.classList.remove('buy-tabs__card--hidden');
          const subscriptionAvailable = currentVariantHasSubscription && currentPackHasSubscription;
          if (subscriptionAvailable) {
            subscriptionCard.classList.remove('buy-tabs__card--disabled');
          } else {
            subscriptionCard.classList.add('buy-tabs__card--disabled');
          }
        }
      }
    }

    /**
     * Updates the subscription availability state for the current variant/pack.
     * Adds visual disabled state to subscription card when unavailable.
     */
    function updateSubscriptionCardState() {
      currentVariantHasSubscription = checkVariantHasSubscription();
      currentPackHasSubscription = checkPackHasSubscription();
      updateCardsVisual();
    }

    /**
     * Liquid `money` can include trusted theme-generated HTML (Transcy wraps it),
     * so preserve the markup when copying displayed prices.
     * @param {Element | null | undefined} priceEl
     * @returns {string}
     */
    function getTrustedPriceHtml(priceEl) {
      return priceEl?.innerHTML?.trim() || '';
    }

    /**
     * Updates the price shown on the "Achat unique" card.
     * Reads from the selected pack card when a pack is active, otherwise from product-price.
     */
    function updateSinglePurchasePrice() {
      const singlePriceEl = buyTabsSection.querySelector('[data-single-price]');
      if (!singlePriceEl) return;

      const targetPrice = singlePriceEl.querySelector('.price');
      if (!targetPrice) return;

      let sourcePrice = null;

      // If a pack is selected, read price from the selected pack card
      const selectedPackRadio = buyTabsSection.querySelector('product-packs-component .product-packs__radio:checked');
      if (selectedPackRadio) {
        const packCard = selectedPackRadio.closest('.product-packs__card');
        if (packCard) {
          sourcePrice = packCard.querySelector('.product-packs__price .price:not(.price--compare)');
        }
      }

      // Fallback to product-price element
      if (!sourcePrice) {
        const sectionEl = buyTabsSection.closest('.shopify-section');
        if (!sectionEl) return;

        const productPrice = sectionEl.querySelector('product-price');
        if (!productPrice) return;

        const priceContainer = productPrice.querySelector('[ref="priceContainer"]');
        if (!priceContainer) return;

        // Remise de code promo affichée : la carte « Achat unique » garde le prix réel du panier
        sourcePrice =
          priceContainer.querySelector('[data-regular-price]') ||
          priceContainer.querySelector('.price:not(.price--compare)');
      }

      if (!sourcePrice) return;

      targetPrice.setAttribute('shimmer', '');
      targetPrice.innerHTML = getTrustedPriceHtml(sourcePrice);
      setTimeout(() => { targetPrice.removeAttribute('shimmer'); }, 500);
    }

    /**
     * Updates the price shown on the subscription card, including the struck-through
     * reference price when the subscription is cheaper.
     * @param {HTMLInputElement | null} [selectedRadio]
     */
    function updateSubscriptionPurchasePrice(selectedRadio = null) {
      const subscriptionPriceEl = buyTabsSection.querySelector('[data-subscription-price]');
      if (!subscriptionPriceEl) return;

      const radio =
        selectedRadio ||
        subscriptionPicker?.querySelector('.subscription-plans-picker__radio[data-radio-type="selling_plan"]:checked') ||
        subscriptionPicker?.querySelector('.subscription-plans-picker__radio[data-radio-type="selling_plan"]');

      if (!(radio instanceof HTMLInputElement)) {
        subscriptionPriceEl.textContent = '';
        return;
      }

      const subscriptionPriceHtml = radio.dataset.variantPrice?.trim();
      if (!subscriptionPriceHtml) {
        subscriptionPriceEl.textContent = '';
        return;
      }

      const subscriptionPriceValue = Number(radio.dataset.variantPriceValue);
      const originalPriceValue = Number(radio.dataset.discountReferencePriceValue ?? radio.dataset.originalVariantPriceValue);
      // Compare the selected allocation's two prices, never a price copied
      // from the product/pack UI (which may already include a reduction).
      const originalPriceHtml = (radio.dataset.discountReferencePrice ?? radio.dataset.originalVariantPrice)?.trim() || '';
      const showOriginalPrice =
        originalPriceHtml &&
        Number.isFinite(subscriptionPriceValue) &&
        Number.isFinite(originalPriceValue) &&
        subscriptionPriceValue < originalPriceValue;

      subscriptionPriceEl.textContent = '';

      const price = document.createElement('span');
      price.className = 'price';
      // Prix par pays (réglage du bloc) : il prime sur le prix du plan, y compris
      // après un changement de variante ou de fréquence, sinon ce rebuild le
      // réécraserait par le montant de la boutique.
      const countryPrice = subscriptionPriceEl.dataset.countryPrice;
      if (countryPrice) {
        price.textContent = countryPrice;
      } else {
        price.innerHTML = subscriptionPriceHtml;
      }
      subscriptionPriceEl.appendChild(price);

      if (showOriginalPrice) {
        const comparePrice = document.createElement('span');
        comparePrice.className = 'buy-tabs__subscription-compare-price';
        comparePrice.dataset.subscriptionComparePrice = '';
        comparePrice.innerHTML = originalPriceHtml;
        subscriptionPriceEl.appendChild(comparePrice);
      }

      if (subscriptionRibbon) subscriptionPriceEl.appendChild(subscriptionRibbon);

      updateSubscriptionSavings(subscriptionPriceValue, originalPriceValue);
      updateSubscriptionDiscountCopy(subscriptionPriceValue, originalPriceValue);
    }

    /**
     * Refreshes every sentence that states the discount percentage — the ribbon
     * and the duration line — and hides them when the selected plan is not
     * actually cheaper, so the page never announces a reduction the customer
     * would not get at checkout.
     * @param {number} subscriptionPriceValue - subscription price, in cents.
     * @param {number} originalPriceValue - selected reference price, in cents.
     */
    function updateSubscriptionDiscountCopy(subscriptionPriceValue, originalPriceValue) {
      const elements = buyTabsSection.querySelectorAll('[data-discount-template], [data-discount-html]');

      const diff = originalPriceValue - subscriptionPriceValue;
      const hasDiscount = Number.isFinite(diff) && diff > 0 && originalPriceValue > 0;
      const percentage = hasDiscount ? Math.round((diff * 100) / originalPriceValue) : 0;
      currentDiscountPercentage = percentage;
      updateAddToCartLabel();

      elements.forEach((element) => {
        if (!(element instanceof HTMLElement)) return;

        if (!hasDiscount || percentage <= 0) {
          element.hidden = true;
          return;
        }

        // Plain sentences carry `data-discount-template`; benefit list items come
        // from a rich-text setting and carry their markup in `data-discount-html`.
        const { discountTemplate, discountHtml } = element.dataset;
        const template = discountTemplate ?? discountHtml;
        if (!template) return;

        element.hidden = false;
        const filled = template.replace('[discount]', `${percentage}%`);
        if (discountTemplate) {
          element.textContent = filled;
        } else {
          element.innerHTML = filled;
        }
      });
    }

    /**
     * Refreshes the "Vous économisez X" row from the current prices.
     * The template string carries an [amount] placeholder filled here.
     * @param {number} subscriptionPriceValue - subscription price, in cents.
     * @param {number} originalPriceValue - selected reference price, in cents.
     */
    function updateSubscriptionSavings(subscriptionPriceValue, originalPriceValue) {
      const savingsEl = buyTabsSection.querySelector('[data-subscription-savings]');
      if (!savingsEl) return;

      const template = savingsEl.dataset.savingsTemplate;
      const moneyFormat = savingsEl.dataset.moneyFormat;
      if (!template || !moneyFormat) return;

      const diff = originalPriceValue - subscriptionPriceValue;
      if (!Number.isFinite(diff) || diff <= 0) {
        savingsEl.hidden = true;
        return;
      }

      const percentage = originalPriceValue > 0 ? Math.round((diff * 100) / originalPriceValue) : 0;

      savingsEl.hidden = false;
      savingsEl.textContent = template
        .replace('[amount]', formatMoney(diff, moneyFormat))
        .replace('[discount]', `${percentage}%`);
    }

    /**
     * Minimal money formatter matching the shop's `money_format` for the
     * amount/amount_with_comma_separator variants used by this theme.
     * Drops the decimals of round amounts, like `money_without_trailing_zeros`.
     * @param {number} cents
     * @param {string} format
     * @returns {string}
     */
    function formatMoney(cents, format) {
      const amount = cents / 100;
      const useComma = /amount_with_comma_separator|amount_no_decimals_with_comma_separator/.test(format);
      const noDecimals = /no_decimals/.test(format) || cents % 100 === 0;
      let value = noDecimals ? Math.round(amount).toString() : amount.toFixed(2);
      if (useComma) value = value.replace('.', ',');
      return format.replace(/\{\{\s*[a-z_]+\s*\}\}/, value);
    }

    /**
     * Enables or disables the add-to-cart button based on variant availability.
     * @param {boolean} isAvailable
     */
    function syncButtonAvailability(isAvailable) {
      const formWrapper = buyTabsSection.querySelector('.buy-tabs__form-wrapper');
      if (!formWrapper) return;

      const productForm = formWrapper.querySelector('product-form-component');
      if (!productForm) return;

      const addToCartButtonContainer = productForm.querySelector('add-to-cart-component');
      if (addToCartButtonContainer) {
        if (isAvailable) {
          if (typeof addToCartButtonContainer.enable === 'function') {
            addToCartButtonContainer.enable();
          }
        } else {
          if (typeof addToCartButtonContainer.disable === 'function') {
            addToCartButtonContainer.disable();
          }
        }
      }

      const acceleratedCheckoutButton = productForm.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (acceleratedCheckoutButton) {
        if (isAvailable) {
          acceleratedCheckoutButton.removeAttribute('hidden');
        } else {
          acceleratedCheckoutButton.setAttribute('hidden', 'true');
        }
      }
    }

    // Listen for variant:update events to update subscription card state and button availability
    const section = buyTabsSection.closest('.shopify-section');
    if (section) {
      section.addEventListener('variant:update', (event) => {
        const eventTarget = event.target;
        if (!(eventTarget instanceof HTMLElement)) return;

        const sourcePicker = eventTarget.closest('variant-picker');
        if (!sourcePicker || !buyTabsSection.contains(sourcePicker)) return;

        // Update button and card availability based on variant
        const variant = event.detail?.resource;
        const isAvailable = variant?.available !== false && variant != null;
        currentVariantAvailable = isAvailable;

        // Apply immediately, then re-apply after morph + subscription-plans.js have run
        syncButtonAvailability(isAvailable);
        updateCardsVisual();
        setTimeout(() => {
          updateSubscriptionCardState();
          switchToSingleIfNoSubscription();
        }, 150);
        setTimeout(() => {
          syncButtonAvailability(isAvailable);
          updateSubscriptionCardState();
          updateSinglePurchasePrice();
          updateSubscriptionPurchasePrice();
        }, 300);
        setTimeout(() => {
          syncButtonAvailability(isAvailable);
          updateSubscriptionCardState();
          updateSubscriptionPurchasePrice();
        }, 600);
      });
    }

    // Listen for variant picker changes directly
    const variantPicker = buyTabsSection.querySelector('variant-picker');
    if (variantPicker) {
      variantPicker.addEventListener('change', () => {
        setTimeout(() => {
          updateSubscriptionCardState();
          switchToSingleIfNoSubscription();
          updateSubscriptionPurchasePrice();
        }, 100);
      });
    }

    if (subscriptionPicker) {
      subscriptionPicker.addEventListener('selling-plan:update', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLElement) || !buyTabsSection.contains(target)) return;

        const selectedRadio = subscriptionPicker.querySelector(
          '.subscription-plans-picker__radio[data-radio-type="selling_plan"]:checked'
        );
        updateSubscriptionPurchasePrice(selectedRadio instanceof HTMLInputElement ? selectedRadio : null);
      });
    }

    // Listen for pack selection changes to update the "Achat unique" card price and subscription state
    const packComponent = buyTabsSection.querySelector('product-packs-component');
    if (packComponent) {
      packComponent.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement) || !event.target.classList.contains('product-packs__radio')) return;

        // Update subscription state directly from the clicked pack radio
        currentPackHasSubscription = event.target.dataset.hasSellingPlans === 'true';
        updateCardsVisual();
        // Keep the pack selection when switching to single mode due to pack change
        switchToSingleIfNoSubscription(true);

        const singlePriceEl = buyTabsSection.querySelector('[data-single-price]');
        if (!singlePriceEl) return;

        const targetPrice = singlePriceEl.querySelector('.price');
        if (!targetPrice) return;

        // Read price directly from the selected pack card
        const packCard = event.target.closest('.product-packs__card');
        if (!packCard) return;

        const packPrice = packCard.querySelector('.product-packs__price .price:not(.price--compare)');
        if (packPrice) {
          targetPrice.setAttribute('shimmer', '');
          targetPrice.innerHTML = getTrustedPriceHtml(packPrice);
          setTimeout(() => { targetPrice.removeAttribute('shimmer'); }, 500);
        }

        updateSubscriptionPurchasePrice();
      });
    }

    // Initial state - check both variant and pack subscription availability
    setTimeout(() => {
      updateSubscriptionCardState();
      switchToSingleIfNoSubscription();
      updateSubscriptionPurchasePrice();
    }, 200);
  });
})();
